// extracted by mini-css-extract-plugin
export default {"cls1":"r8RqJEAnVaFbGw3KVWHA","cls2":"NUV9XkL44keajpQgWNfp r8RqJEAnVaFbGw3KVWHA"};